import { Injectable } from '@angular/core';

import { Consorcio } from '../model/Consorcio';
import { Sucursal } from '../model/sucursal';
import { DocumentoSalida } from '../model/documento-salida';

import { Http, Response, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';

import { UtilitiesService } from '../services/utilities.service'
import { Resultado } from 'app/model/resultado';


@Injectable()
export class DocumentoSalidaService {

  constructor(
    private _http: Http,
    private _utilities: UtilitiesService
  ) { }

  getDocumentos(query: any): Observable<DocumentoSalida[]> {

    let json = { "Metodo": "findDocumentoSalida", "Datos": query };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());

  }

  getDocumentosExtradaData(codigoConsorcio: string, codigoSucursal: string): Observable<DocumentoSalida[]> {

    const requestUrl = this._utilities.getURLIIS('DocumentoSalida/salida/' + codigoConsorcio + '/' + codigoSucursal);

    return this._http.get(requestUrl).map((response: Response) => {
      return <DocumentoSalida[]>response.json();
    });

  }

  public insert(documento: DocumentoSalida): Observable<Resultado> {

    // let json = {   "Metodo": "postDocumentoSalida",   "Datos": documento  };

    // let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
    // let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

    // return this._http.post(this._utilities.getURL("post"), 
    // 		params, {headers: headers}).map(res => res.json());

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let url = this._utilities.getURLIIS("DocumentoSalida/documentoSalida/");

    let params = JSON.stringify(documento);

    return this._http.post(url, documento, { headers: headers }).map(res => res.json());

  }

  // public aprobar(query: any) {

  //   let json = { "Metodo": "aprobarDocumentoSalida", "Datos": query };

  //   let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
  //   let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });


  //   return this._http.post(this._utilities.getURL("post"),
  //     params, { headers: headers }).map(res => res.json());
  // }


  public aprobar(idAlmacen: string, idCompania: string, idSucursal: string, idDocumento: string): Observable<Resultado> {

    const requestUrl = this._utilities.getURLIIS('DocumentoSalida/aprobarDocumento/'
      + idAlmacen + '/' + idCompania + '/' + idSucursal + '/' + idDocumento);

    return this._http.get(requestUrl).map((response: Response) => {
      return <Resultado>response.json();
    });
  }

  public delete(documento: DocumentoSalida) {

    let json = { "Metodo": "deleteDocumentoSalida", "Datos": documento };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/services/documento-salida.service.ts